module.exports = __webpack_public_path__ + "media/images/common/icon_file-f4ec793ff97c338e45e6fa2c165be12e.png";